{
  "birthDate": "Tō rā whānau",
  "dateFormat": "dd/mm/yyyy",
  "familyName": "Tō ingoa whānau",
  "helpMessage": "<p>Mēnā kāore i te tika te nama i runga ake, kāore rānei koe i te mōhio me aha, waea mai koa ki <a><strong>{{phone}}</strong></a> (ā, pēhia <strong>Kōwhiringa 2</strong>).</p>",
  "sendCode": "Tukua te waehere",
  "text": "<p>He tono tēnei mō te whakarite wā mō tētahi tūroro e tiakina ana e tētahi kei a ia te nama waea pūkoro: <strong><PhonePlaceholder /></strong></p>\n<p>Mēnā ko koe tēnei, tāurua koa te <strong>ingoa whānau o te tūroro</strong> me te <strong>ra whanau</strong> ki raro nei, ā, pāwhiritia te pātene.</p>\n<p>Mō te haumarutanga, ka tukuna e mātou he <strong>waehere 4-mati</strong> kotahi anake mā te karere hei whakamana i tō tuakiri.</p>",
  "title": "Nau mai ki <strong>{{company}} Online Booking</strong>"
}
